if (!customElements.get('slideshow-carousel')) {
  class SlideshowCarousel extends HTMLElement {
    constructor() {
      super();

      let section = (this.section = this.dataset.section);
      this.selectors = {
        slideshowImages: `.js-slideshow-carousel-images-${section}`,
        slideshowContent: `.js-slideshow-carousel-content-${section}`
      }
  
      this.data = {
        adaptHeight: 'adaptHeight',
        autoplay: 'autoplay',
        autoplaySpeed: 'autoplaySpeed',
        minAspectRatio: 'minAspectRatio',
        minAspectRatioMobile: 'minAspectRatioMobile',
        sliderEffect: 'sliderEffect',
        showDots: 'showDots'
      }

      this.attr = {
        currentSlide: 'data-current-slide'
      }
  
      this.settings = {
        adaptHeight: this.dataset[this.data.adaptHeight] == 'true',
        autoplay: this.dataset[this.data.autoplay] == 'true',
        autoplaySpeed: parseInt(this.dataset[this.data.autoplaySpeed] || 5000),
        sliderEffect: this.dataset[this.data.sliderEffect] || 'default',
        showDots: this.dataset[this.data.showDots] == 'true'
      }

      if (
        !this.querySelector(this.selectors.slideshowImages) &&
        !this.querySelector(this.selectors.slideshowContent)
      ) return;

      this.mqlSmall = window.matchMedia('(max-width: 749px)');
  
      this.init();
      
    }
  
    init() {
      if (this.querySelector(this.selectors.slideshowContent)) this.setupSlideshowContent();
      if (this.querySelector(this.selectors.slideshowImages)) this.setupSlideshowImages();
      this.initSliders();
      this.syncSliders();
      

      if (
        this.querySelector(this.selectors.slideshowImages) &&
        this.settings.adaptHeight
      ) {
        this.setSlideshowHeight();
        
        window.addEventListener(
          'resize',
          debounce((event) => {
            this.setSlideshowHeight();
          }, ON_RESIZE_DEBOUNCE_TIMER)
        );
      }
      
    }
  
    setupSlideshowImages() {
      let settings = {
        init: false,
        loop: true,
        speed: 600,
        autoHeight: false,
        preventInteractionOnTransition: true,
        slidesPerView: 1
      };

      if (this.settings.autoplay) {
        Object.assign(settings, {
          autoplay: {
            delay: this.settings.autoplaySpeed
          }
        });
      };

      // if (this.slideshowContent) {
      //   Object.assign(settings, {
      //     thumbs: {
      //       swiper: this.slideshowContent
      //     }
      //   });
      // }

      if (this.settings.sliderEffect !== 'default') {
        if (this.settings.sliderEffect == 'fade') {
          Object.assign(settings, {
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            }
          });
        }
      }

      this.slideshowImages = new Swiper(this.selectors.slideshowImages, settings);
      
    }
  
    setupSlideshowContent() {
      let settings = {
        init: false,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 600,
        slidesPerView: 1,
        autoHeight: true,
        allowTouchMove: false,
        on: {
          activeIndexChange: (slideshowContent) => {
            slideshowContent.el.setAttribute(this.attr.currentSlide, slideshowContent.activeIndex);
          }
        }
      };

      if (this.settings.showDots) {
        Object.assign(settings, {
          pagination: {
            el:'.swiper-pagination',
            clickable: true
          }
        });
      };
      
      this.slideshowContent = new Swiper(this.selectors.slideshowContent, settings);
      
    }

    syncSliders() {
      if (!this.slideshowContent || !this.slideshowImages) return;
      this.slideshowContent.controller.control = this.slideshowImages;
      this.slideshowImages.controller.control = this.slideshowContent;
    }
    
    initSliders() {
      if (this.slideshowContent) this.slideshowContent.init();
      if (this.slideshowImages) this.slideshowImages.init();          
      
    }

    setSlideshowHeight() {
      const minAspectRatio = this.mqlSmall.matches ? (parseFloat(this.dataset[this.data.minAspectRatioMobile]) || 0.7) : (parseFloat(this.dataset[this.data.minAspectRatio]) || 2);
      this.slideshowImages.el.style.height = `${document.documentElement.scrollWidth / minAspectRatio}px`;
      
    }
    
  }

  customElements.define('slideshow-carousel', SlideshowCarousel);
}